/*eslint-disable*/
import React from 'react'

import TicketImg from '../../assets/images/bus/Tickets.png'
import ParcelImg from '../../assets/images/bus/Parcel.png'
import CargoImg from '../../assets/images/bus/Cargo.png'
import BusImg from '../../assets/images/bus/Bus.png'

export const serviceData = [
  {
    slug: 'bus-ride-service',
    heroHead: 'Want to book a ride? Oya is here.',
    image: TicketImg,
    heroPara: `Purchase a ticket and book trips in advance at your convenience with just a click of a button.
With Oya, moving around just got easier. Your days of paper tickets are over!
Buy a ticket and enrol in a bus and voila you have a digital copy of your receipt and view your route in real-time. With our secure payment integration, every purchase is secured and seamless.
`,

    head2: 'Want to book a ride?',
    para1:
      '',

    para2:
      '',

    para3:
      '',

    para4:
      '',

    para5:
      '',

    para6:
      '',

    service: [
      {
        title: 'Ticketing',
        icon: 'ticketing.png',
        desc: 'Easily purchase a ticket via the Oya! App or at a loading point.'
      },
      {
        title: 'Join At Mid-route & Joining At Station ',
        icon: 'mid.png',
        desc: `Passengers can purchase a mid-route ticket with the Oya! App, choose a pickup point and
        conveniently wait to be picked up by the bus without going to the station.
        Passengers can also purchase a ticket and onboard a bus at the station
        `
      },
      {
        title: 'Advance Booking',
        icon: 'booking.png',
        desc: 'Passengers can schedule and book a ticket in advance of the trip.'
      },
      {
        title: 'Electronic Payment',
        icon: 'payment.png',
        desc: 'Passengers can purchase tickets via, MTN Momo, Vodacash and Airtigo Cash.'
      }
    ]
  },
  {
    slug: 'parcel',
    heroHead: 'Want to send a Parcel?',
    image: ParcelImg,
    heroPara: `Receive and deliver your consignment safely to its destination with just a click of a button. Your
    days of unnecessary hassle locating your consignment are over! With our smart parcel service,
    you can track and easily locate your consignment in real-time. Life just got better with Oya.`,

    head2: 'Want to book a ride?',
    para1:
      '',

    para2:
      '',

    para3:
      '',

    para4:
      '',

    para5:
      '',

    para6:
      '',
    service: [
      {
        title: 'Dispatch Rider Service',
        icon: 'dispatch.png',
        desc: `Deliver and receive all your consignments in a professional and secure manner.`
      },
      {
        title: 'Track Your Parcel',
        icon: 'location.png',
        desc: 'Track your consignments in real time from source to destination with Oya!.'
      }
    ]
  },
  {
    slug: 'cargo-truck-service',
    heroHead: 'Our Cargo-Truck Service',
    image: CargoImg,
    heroPara: `We offer both a door-to-door airfreight service or airport-to-airport airfreight service from  other countries to Ghana. With our door-to-door air freight service, we will clear your goods at Customs and deliver at your recipient's doorstep in Ghana.`,
    head2: 'Want to book a ride?',
    para1:
      '',

    para2:
      '',

    para3:
      '',

    para4:
      '',

    para5:
      '',

    para6:
      '',
    service: []
  },
  {
    slug: 'hiring',
    heroHead: 'Want to hire a ride?',
    image: BusImg,
    heroPara: `Easily hire a bus for your business retreat, family vacation and road trips with Oya.
Your days of hassling to hire a bus with a reliable driver are over!
Oya helps you organize your itinerary and contribute to your safe travel.  
`,

    head2: 'Want to book a ride?',
    para1:
      '',

    para2:
      '',

    para3:
      '',

    para4:
      '',

    para5:
      '',

    para6:
      '',
    service: [
      {
        title: 'Special Hiring Service',
        icon: 'hire.png',
        desc: 'this is a service one text'
      },
      {
        title: ' Normal Hiring Service ',
        icon: 'hire.png',
        desc: 'this is a service two text'
      }
    ]
  }
]
